import { Component, EventEmitter, Input, Output, Self } from '@angular/core';
import { FolderTreeNode } from '../../typescript-angular-client/model/folderTreeNode';
import { FileModel } from '../../typescript-angular-client/model/fileModel';
import { NewFilesListService } from '../files-list/files-list.service';
import { takeUntil } from 'rxjs/operators';
import { NgOnDestroyService } from '../services/ng-on-destroy.service';

@Component({
  selector: 'file-manager-command',
  templateUrl: './file-manager-command.html',
  providers: [NgOnDestroyService]
})
export class FileManagerCommandComponent {
  @Output() addFolderAction = new EventEmitter<unknown>();
  @Output() renameItemAction = new EventEmitter<unknown>();
  @Output() deleteItemAction = new EventEmitter<unknown>();
  @Output() syncImagesAction = new EventEmitter<unknown>();
  public currentNode: FolderTreeNode;

  @Input() dialogType: FileModel.FileTypeEnum;
  @Input() showExportButton: boolean;

  @Input()
  set currentFolder(value: FolderTreeNode) {
    this.currentNode = value;
    this.addNewFolderButtonDisabled = (value === null) || this.filesOnlyMode;
    this.renamedButtonDisabled = true;
    this.deleteButtonDisabled = true;
  }

  @Input()
  set selectedItemsInList(value: Array<FileModel>) {
    this.addNewFolderButtonDisabled = this.currentNode === null || this.filesOnlyMode;
    this.deleteButtonDisabled = !value || value.length === 0;
    this.renamedButtonDisabled = !value || value.length !== 1;
  }

  public deleteButtonDisabled: boolean;
  public renamedButtonDisabled: boolean;
  public addNewFolderButtonDisabled: boolean;
  public filesOnlyMode: boolean;

  constructor(
    newFilesListService: NewFilesListService,
    @Self() private ngOnDestroy$: NgOnDestroyService
  ) {
    this.addNewFolderButtonDisabled = this.renamedButtonDisabled = this.deleteButtonDisabled = true;
    newFilesListService.isFilesOnlyMode$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe((filesOnlyMode) => {
        this.filesOnlyMode = filesOnlyMode;
        this.addNewFolderButtonDisabled = (this.currentNode === null) || this.filesOnlyMode;
      });
  }

  public onAddFolderClicked = (): void => this.addFolderAction.emit();

  public onRenameListItemClicked = () => this.renameItemAction.emit();

  public onDeleteListItemClicked = () => this.deleteItemAction.emit();

  public onSyncImagesClicked = () => this.syncImagesAction.emit();
  
}
